import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './style.css'

export const DialogConfirm = ({ open, setOpen, obj }) => {
    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={obj.icon} alt="quitar relación" />
                </div>
                <div className='text'>
                    <h3>{obj.title}</h3>
                    <p>{obj.question}</p>
                </div>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='cancel' onClick={() => setOpen(false)}>Cancelar</button>
                <button className='approve' onClick={obj.answer}>Quitar</button>
            </DialogActions>
        </Dialog>
    );

}